import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { StoryTag } from '../model/story/story-tag.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private httpClient = inject(HttpClient);

  public getTagList(): Observable<StoryTag[]> {
    return this.httpClient.get<any[]>(
      `${environment.apiUrl}/api/tags`,
    ).pipe(
      map((responseList: any[]): StoryTag[] => (responseList ?? []).map(
        (response: any): StoryTag => StoryTag.createFromApi(response),
      )),
    );
  }

  public searchTag(filter: string): Observable<StoryTag[]> {
    const params = new HttpParams().set('filter', filter);
    return this.httpClient.get<StoryTag[]>(
      `${environment.apiUrl}/api/tags`,
      {params},
    ).pipe(
      map((responseList: any[]): StoryTag[] => (responseList ?? []).map(
        (response: any): StoryTag => StoryTag.createFromApi(response),
      )),
    );
  }

  public createTag(name: string): Observable<StoryTag> {
    return this.httpClient.post<StoryTag>(
      `${environment.apiUrl}/api/tags`,
      {name},
    )
      .pipe(
        map((response: { id: string }): StoryTag =>
          StoryTag.createFromApi({
            id: response.id,
            name: name,
          }),
        ),
      );
  }

}
